export const FAST_TRACK_DATA = [
  {
    courseDuration: "Saturday, 21st June 2025",
    courseTime: "10 AM - 2 PM EST 🇨🇦🇺🇸 3 PM - 7PM BST  🇬🇧🇳🇬",
    bonus: "leverage your past experience",
    rating: "Completely FREE",
  },
  {
    courseDuration: "25th-26th Jan., 2025",
    courseTime: "9AM - 12PM EST",
    bonus: "AI Job Search Strategy",
    rating: "4PM - 7PM EST",
  },
  {
    courseDuration: "4th Jan 2025",
    courseTime: "4 Weeks",
    bonus: "None",
    rating: "Saturdays & Tuesdays",
  }
]